import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_LIBRARY_CONTENT: 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null,
                response: null
            }
        case ActionTypes.RECEIVED_LIBRARY_CONTENT: 
            return {
                ...state,
                loading: false,
                response: action.res,              
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_LIBRARY_CONTENT:
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_LIBRARY_CONTENT:
            return { }
        default :  return state
    }
}



const dispatchRequestLibraryContent = () => ({
    type: ActionTypes.REQUEST_LIBRARY_CONTENT
})

const dispatchReceivedLibraryContent = res => ({
    type: ActionTypes.RECEIVED_LIBRARY_CONTENT,
    res
})

const dispatchErrorLibraryContent = err => ({
    type: ActionTypes.ERROR_LIBRARY_CONTENT,
    err
})

const dispatchClearLibraryContent = () => ({
    type: ActionTypes.CLEAR_LIBRARY_CONTENT
})

export const clearLibraryContentData = () => dispatchClearLibraryContent();


export const getLibraryContentInfo = (subject_id, topic_id) => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestLibraryContent({subject_id, topic_id}));       
            const options = {
                method: 'post',
                url: `${baseUrl}/api/content_in_libray`,
                data: {                    
                    subject_id,
                    topic_id
                },           
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedLibraryContent(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorLibraryContent(e.response)));
}